(() => {
  const container = document.querySelector('.policy-page, .shopify-policy__container');
  const isNativePolicy = container?.classList.contains('shopify-policy__container');
  const title = container?.querySelector('.policy-page__header, .shopify-policy__title');
  const titleHeading = title?.querySelector('h1');
  const content = container?.querySelector('.policy-page__content, .shopify-policy__body > .rte');

  if (!container || !title || !titleHeading || !content) return;

  if (isNativePolicy && !title.querySelector('.policy-page__eyebrow')) {
    const eyebrow = document.createElement('p');

    eyebrow.className = 'policy-page__eyebrow';
    eyebrow.textContent = 'Policies & information';
    title.prepend(eyebrow);
  }

  if (isNativePolicy && !container.querySelector('.policy-page__nav')) {
    const rootPath = window.Shopify?.routes?.root || '/';
    const policyLinks = [
      ['Returns', `${rootPath}pages/return-policy`],
      ['Shipping', `${rootPath}policies/shipping-policy`],
      ['Privacy', `${rootPath}pages/privacy-policy`],
      ['Terms', `${rootPath}policies/terms-of-service`],
      ['Accessibility', `${rootPath}pages/accessibility-policy`]
    ];
    const nav = document.createElement('nav');

    nav.className = 'policy-page__nav';
    nav.setAttribute('aria-label', 'Store policies');

    policyLinks.forEach(([label, href]) => {
      const link = document.createElement('a');
      const linkPath = new URL(href, window.location.origin).pathname.replace(/\/$/, '');
      const currentPath = window.location.pathname.replace(/\/$/, '');

      link.href = href;
      link.textContent = label;

      if (linkPath === currentPath) {
        link.setAttribute('aria-current', 'page');
      }

      nav.appendChild(link);
    });

    title.after(nav);
  }

  Array.from(content.childNodes).forEach((node) => {
    if (node.nodeType !== Node.TEXT_NODE) return;

    const text = node.textContent || '';

    const looksLikeGeneratorCss = text.includes('{')
      && text.includes('}')
      && (/data-custom-class|list-style-type|font-family\s*:/i.test(text));

    if (looksLikeGeneratorCss) {
      node.remove();
    }
  });

  content.querySelectorAll('[style]').forEach((element) => {
    if (!(element instanceof HTMLElement)) return;

    element.removeAttribute('style');
  });

  const normalizedTitle = titleHeading.textContent?.replace(/\s+/g, ' ').trim().toLowerCase() || '';
  const duplicateTitle = Array.from(content.querySelectorAll('.MsoNormal, [data-custom-class="title"], h1')).find((element) => {
    return element.textContent?.replace(/\s+/g, ' ').trim().toLowerCase() === normalizedTitle;
  });

  duplicateTitle?.remove();

  content.querySelectorAll('.MsoNormal').forEach((element) => {
    if (element.textContent?.trim() || element.querySelector('img, table, iframe, video, svg')) return;

    element.remove();
  });

  content.querySelectorAll('div').forEach((element) => {
    const text = element.textContent?.replace(/\s+/g, ' ').trim() || '';
    const directStrong = element.querySelector(':scope > strong, :scope > span > strong');
    const isShortHeading = text.length > 2 && text.length < 120 && text === text.toUpperCase();

    if (directStrong && isShortHeading) {
      element.classList.add('policy-generated-heading');
    }
  });
})();
